import axios from "axios";

let affiliateSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const supportAxiosinstance = axios.create({
	baseURL: affiliateSvc,
});

export default {
	beneficiariesService: {
		searchBeneficiaries(beneficiariesFilter, token) {
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/plus/users/search",
				beneficiariesFilter,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getBeneficiaryDetails(beneficiaryId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/plus/users/" + beneficiaryId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getBeneficiaryDetailsCore(holderId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/rlc/holders/" + holderId + "/accounts",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		cardsAction(cardActionOrder, accountId, cardId, token, user) {
			let config = {};
			if (user !== null) {
				config = {
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
						"X-Up-User": user,
					},
				};
			} else {
				config = {
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				};
			}
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/rlc/accounts/" + accountId +
				"/cards/" + cardId +
				"/cards_action",
				cardActionOrder,
				config
			);
		},
		deleteMobileAccount(beneficiaryId, token) {
			return supportAxiosinstance.delete(
				companyRoot +
				"/v1/plus/users/" +
				beneficiaryId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		updateMobileAccount(beneficiaryId, mobileData, token) {
			return supportAxiosinstance.put(
				companyRoot +
				"/v1/plus/users/" +
				beneficiaryId,
				mobileData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getComplaintStatuses(token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/issues/statuses",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getComplaintUsers(token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/issues/users",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getComplaintTitles(token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/issues/titles",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		searchComplaints(complaintsFilter, token) {
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/issues/search",
				complaintsFilter,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getComplaintDetails(complaintId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/issues/" + complaintId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getComplaintComments(complaintId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/issues/" + complaintId + "/comments",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getComplaintNotes(complaintId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/issues/" + complaintId + "/notes",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		putComplaintNotes(complaintId, note, token) {
			return supportAxiosinstance.put(
				companyRoot +
				"/v1/issues/" + complaintId + 
				"/notes" + note.id,
				note,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		addComplaintNotes(complaintId, notes, token) {
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/issues/" + complaintId + 
				"/notes",
				notes,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addComplaintState(complaintId, state, token) {
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/issues/" + complaintId + 
				"/states",
				state,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		modifyComplaintState(complaintId, state, token) {
			return supportAxiosinstance.put(
				companyRoot +
				"/v1/issues/" + complaintId + 
				"/states",
				state,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		unAssignToComplaint(complaintId,  token) {
			return supportAxiosinstance.delete(
				companyRoot +
				"/v1/issues/" + complaintId + 
				"/states",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
	},
};
